// extracted by mini-css-extract-plugin
module.exports = {"halo":"TransactionDetailsError_halo__MjJBz","logoDarkFill":"TransactionDetailsError_logoDarkFill__GffK_"};